import * as APIBase from './APIBase';

export default class QRAuthApi {
  static post() {
    const body = new URLSearchParams({
      scope: 'profile openid',
      client_id: 'headunit',
      response_type: 'token id_token',
      nonce: 'foo',
    });
    // return APIBase.getAuthData();
    return APIBase.postAPI('/oauth2/realms/root/realms/tmna/device/code', true, body);
  }

}
